import { useMemo, useState } from 'react';
import * as Yup from 'yup';
import { useValidator } from '../../../utils/hooks';
import { ICancellationFormData } from '../cus-cancellation-form.data';
import { ICusCancellationFormResources } from '../cus-cancellation-form.props.autogenerated';

const ONLY_ORDER_REGEX = /OL\d{10}/i;
const WRONG_STORE_TEST_NAME = 'no-only-order';

const formDataInitial: ICancellationFormData = {
    email: null,
    orderNumber: null
};

const formSchemaProvider = (resources: ICusCancellationFormResources) =>
    Yup.object({
        email: Yup.string()
            .email(resources.orderLookupEmailValidationErrorMessage)
            .required(resources.orderLookupEmailValidationErrorMessage),
        orderNumber: Yup.string()
            .required(resources.orderLookupOrderNumberValidationErrorMessage)
            .test(WRONG_STORE_TEST_NAME, resources.cancellationFormWrongStoreErrorMessage, value => !ONLY_ORDER_REGEX.test(value ?? ''))
    });

export default function useCancellationForm(resources: ICusCancellationFormResources) {
    const [formData, setFormData] = useState<ICancellationFormData>(formDataInitial);
    const formSchema = useMemo(() => formSchemaProvider(resources), [resources]);

    const { errors, isValid } = useValidator(formSchema, formData);

    const updateFormData = (field: keyof ICancellationFormData, value: ICancellationFormData[keyof ICancellationFormData]) => {
        setFormData(prevData => ({
            ...prevData,
            [field]: value
        }));
    };

    const clearFormData = () => {
        setFormData(formDataInitial);
    };

    return {
        formData,
        updateFormData,
        clearFormData,
        errors,
        isValid
    };
}
